import { TwitterTweetEmbed } from "react-twitter-embed";
import React from "react";

const Mentions = () => {
  return (
    <div>
      <div>
        <div className="mx-auto max-w-7xl py-20 px-6 lg:px-8">
          <div className="text-center">
            <h2 className="text-base font-semibold text-emerald-600">
              Mentions
            </h2>
            <p className="mt-1 text-3xl font-bold tracking-tight text-slate-900 sm:text-5xl">
              Join 500+ Developers
            </p>
            <p className="mx-auto mt-3 max-w-xl text-base text-slate-500">
              Don't just take our word for it, see how other devs are using
              ExtensionKit to jumpstart their extension projects
            </p>
          </div>
        </div>
      </div>
      <div className="lg:grid lg:grid-cols-3 lg:space-x-10 mx-auto max-w-7xl px-6 lg:px-8">
        <div>
          <TwitterTweetEmbed tweetId={"1325327757220347905"} />
        </div>
        <div>
          <TwitterTweetEmbed
            tweetId={"1315999912245506053"}
            options={{
              cards: "hidden",
            }}
          />
        </div>
        <div>
          <TwitterTweetEmbed tweetId={"1298869342768181248"} />
        </div>
      </div>
    </div>
  );
};

export default Mentions;
